<script setup lang="ts">
import { computed } from "vue";
import type { CartesianSerieWithValue } from "../../interfaces";
import LegendLinePreview from "./LegendLinePreview.vue";

const props = defineProps<{
	serie: CartesianSerieWithValue;
	showValue?: boolean;
	selected?: boolean;
}>();

const emit = defineEmits<{
	(e: "click"): void;
}>();

const rightAxis = computed(() => props.serie.yAxis === "right");
</script>

<template>
	<div class="legend-item" :class="rightAxis ? 'right' : ''">
		<!-- <div class="legend-item-icon" :style="iconStyle" /> -->
		<LegendLinePreview :value="serie.style as any" />
		<div class="legend-item-content text-subtitle-2">
			<div
				v-if="serie.label"
				class="legend-item-label ml-1 text-sm"
				:class="selected ? 'selected' : ''"
				@click="emit('click')"
			>
				<slot name="label" :serie="serie">{{ serie.label }}</slot>
			</div>
			<div v-if="showValue" class="legend-item-value border-l-border border-l text-sm">
				<slot name="value" :serie="serie">{{ serie.value }} {{ serie.unit }}</slot>
			</div>
		</div>
	</div>
</template>

<style scoped>
.legend-item {
	float: left;
	display: flex;
	align-items: center;
	margin-bottom: 4px;
	padding-left: 16px;
}

.legend-item.legend--right {
	float: none !important;
	padding-left: 4px !important;
	margin-bottom: 0px !important;
	width: 100% !important;
}

.legend-item.right {
	padding-left: 16px;
	padding-right: 16px;
	float: right;
}

.legend--right.legend-item.right {
	padding-right: 0 !important;
}

.legend-item.right ~ .legend-item.right {
	padding-right: 0;
}

.legend-item-content {
	display: flex;
}

.legend--right .legend-item-content {
	width: 100%;
}

.legend-item-label {
	opacity: 0.8;
	cursor: pointer;
	flex: 1 1 auto;
}

.legend-item-label.selected {
	opacity: 1;
}

.legend-item-label:hover {
	opacity: 1;
}

.legend-item-value {
	flex: 0 1 auto;
	padding-left: 8px;
	margin-left: 8px;
}

.legend-item-icon {
	width: 14px;
	height: 4px;
	border-radius: 2px;
	margin-right: 8px;
}
</style>
